import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import {Common} from '../../shared/common';
@Component({
  selector: 'vc-poll-finished-summary',
  templateUrl: 'poll-finished-summary.component.html',
  styleUrls: ['./poll-finished-summary.component.less', '../../shared/common.less']
})

export class PollFinishedSummaryComponent implements OnInit {
  @Input() description: string;
  @Input() startDate: string;
  @Input() endDate: string;
  @Input() votersCount: number;
  @Input() votersVoted: number;
  @Input() participation: string;
  @Input() resultsShared: boolean;
  @Input() isShareEnabled: boolean;
  @Input() endDateFormat: Date;
  @Input() calculating: boolean;
  @Input() isActive = false;
  @Output() downloadVoters = new EventEmitter<boolean>();
  @Output() shareResults = new EventEmitter<boolean>();
  @Output() return = new EventEmitter<boolean>();
  @Input() type = 'live';
  blockchainLink: string;

  constructor(
    private router: ActivatedRoute,
    public common: Common,
  ) {
  }

  rejoin() {
    this.return.emit(true);
  }

  download() {
    this.downloadVoters.emit(true);
  }

  shareResult() {
    this.shareResults.emit(true);
  }

  ngOnInit() {
    let pollId = '';
    this.router.queryParams.subscribe((params) => {
      pollId = params.poll;
    });
    this.blockchainLink = environment.settings.validation + pollId;
  }
}
